export default (theme) => ({
    panel: {
        position: 'fixed',
        display: 'flex',
        zIndex: 1203,
    },
    panelBottom: {
        bottom: 20,
        right: 50,
        '@media (min-width:381px) and (max-width:767px)': {
            right: 10,
            bottom: 10
        },
        '@media (max-width: 380px)': {
            right: 10,
            bottom: 10
        }
    },
    leftButton: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    rightButton: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
});